import { computed, ModelRef, ref } from "vue";
import dayjs from "dayjs";
import {
  DSDateTimePickerMode,
  DSDateTimePickerModelValue,
} from "@/src/design_system/form_elements/shared/types/dateTimePicker";
import { DSDateTimeFormFieldInputModelValue } from "@/src/design_system/form_elements/shared_modules/date_time_form_field/types";

export const useDateTimePickers = (
  mode: DSDateTimePickerMode,
  modelValue: ModelRef<DSDateTimePickerModelValue>,
  formats: { input: string; hiddenInput: string }
) => {
  const popoverOpen = ref(false);

  const temporalFormattedModelValue = ref<string | null>(null);

  const pickerModelValue = computed<DSDateTimePickerModelValue>({
    get: () => modelValue.value,
    set: (val: DSDateTimePickerModelValue) => {
      modelValue.value = val;
      temporalFormattedModelValue.value = null;
      if (mode === "date") {
        popoverOpen.value = false;
      }
    },
  });

  const formattedModelValue = computed<DSDateTimeFormFieldInputModelValue>({
    get: () => temporalFormattedModelValue.value || (modelValue.value ? modelValue.value!.format(formats.input) : ""),
    set: (val: DSDateTimeFormFieldInputModelValue) => {
      const parsedDate = dayjs(val, formats.input, true);
      if (val && !parsedDate.isValid()) {
        temporalFormattedModelValue.value = val;
        return;
      }
      modelValue.value = val ? parsedDate : null;
      temporalFormattedModelValue.value = null;
    },
  });

  const hiddenInputValue = computed(() => {
    if (temporalFormattedModelValue.value) {
      return "";
    }

    return modelValue.value ? modelValue.value.format(formats.hiddenInput) : "";
  });

  return {
    popoverOpen,
    modelValue,
    temporalFormattedModelValue,
    pickerModelValue,
    formattedModelValue,
    hiddenInputValue,
  };
};
